<template lang="pug">
  .purchasingIntro#purchasing
    .text-block
      h2 Purchasing the Gift
    PurchasingGiftMobile.mobile
    .text-block.two(data-animate="true")
      p Are those reindeer hooves or the mouse clicks and taps of online shoppers we hear? To prevent abandoned carts this season, an online seller's store has to provide a seamless experience. Offering a range of delivery options will put you on the nice list, by providing convenience and choice for busy would-be elves — from expedited delivery, to a buy-online-pick-up-in-store (BOPIS) selection if you have both physical and online stores.
    PurchasingGift.desktop
</template>

<script>
import PurchasingGift from '@/assets/img/svgs/purchasing-gift.svg'
import PurchasingGiftMobile from '@/assets/img/svgs/purchasingGiftMobile.svg'

export default {
  name: 'purchasingIntro',
  props: {
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  computed: {
  },
  methods: {
  },
  components: {
    PurchasingGift,
    PurchasingGiftMobile,
  },
}
</script>

<style scoped lang="scss">
.purchasingIntro {
  padding: 5rem 0;
  position: relative;
  .text-block {
    left: 18%;
    width: 35%;
    top: 10%;
    &.two {
      top: 25%;
    }
  }
  h2 {
    padding-bottom: 3rem;
  }

  @media #{$mobile} {
    text-align: center;
    padding: 5rem 0;
    .text-block {
      position: relative;
      left: auto;
      width: auto;
      top: auto;
      &.two {
        width: 83%;
        margin: 0 auto;
      }
    }

    .mobile {
      width: 76%;
      margin: 0 auto;
      padding: 4rem 0 2rem 0;
    }
  }
}
</style>
